/** @jsx h */
import { labels } from '../config';
import { useRef, useEffect, useState } from 'preact/hooks';

const SearchHeader = ({ query, pluginNamespace }) => {
  const [searchQuery, setSearchQuery] = useState(query);
  const searchInputEl = useRef(null);

  useEffect(() => setSearchQuery(query), [query]);

  function handleInputChange() {
    if (searchInputEl && searchInputEl.current) {
      const value = searchInputEl.current.value;
      setSearchQuery(value);
    }
  }

  function resetQuery() {
    setSearchQuery('');
  }

  return (
    <div className="search-section__input-wrapper">
      <label htmlFor="search-section-input" className="sr-only">
        {labels.search.searchField}
      </label>
      <input
        id="search-section-input"
        className="search-section__input"
        data-main-input
        name={`${pluginNamespace}[q]`}
        value={searchQuery}
        ref={searchInputEl}
        onChange={handleInputChange}
        autocomplete="off"
        placeholder={labels.search.placeholder || ''}
        type="text"
      />

      <div className="search-section__action-wrapper">
        <button
          type="button"
          className="search-section__reset-query-button"
          onClick={resetQuery}
        >
          <span className="sr-only">{labels.faceting.resetQuery}</span>
          <svg
            className="svg-close"
            aria-hidden="true"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g stroke="none" stroke-width="1" fill-rule="evenodd">
              <polygon fill="none" points="0 0 24 0 24 24 0 24" />
              <polygon
                fill="currentColor"
                fill-rule="nonzero"
                transform="translate(11.939340, 12.060660) rotate(135.000000) translate(-11.939340, -12.060660) "
                points="1.43933983 11.0606602 22.4393398 11.0606602 22.4393398 13.0606602 1.43933983 13.0606602"
              />
              <polygon
                fill="currentColor"
                fill-rule="nonzero"
                transform="translate(12.060660, 12.060660) rotate(45.000000) translate(-12.060660, -12.060660) "
                points="1.56066017 11.0606602 22.5606602 11.0606602 22.5606602 13.0606602 1.56066017 13.0606602"
              />
            </g>
          </svg>
        </button>
        <button type="submit" className="search-section__submit-button">
          <span className="sr-only">{labels.search.submit}</span>
          <svg
            className="svg-search"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
          >
            <path
              fill="currentColor"
              transform="translate(-2.000000, -2.000000)"
              d="M18.031,16.617 L22.314,20.899 L20.899,22.314 L16.617,18.031 C15.0237382,19.3082211 13.0420011,20.0029052 11,20 C6.032,20 2,15.968 2,11 C2,6.032 6.032,2 11,2 C15.968,2 20,6.032 20,11 C20.0029052,13.0420011 19.3082211,15.0237382 18.031,16.617 Z M16.025,15.875 C17.2941129,14.5698857 18.002867,12.8204293 18,11 C18,7.132 14.867,4 11,4 C7.132,4 4,7.132 4,11 C4,14.867 7.132,18 11,18 C12.8204293,18.002867 14.5698857,17.2941129 15.875,16.025 L16.025,15.875 L16.025,15.875 Z"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default SearchHeader;
